import React, { useState, useEffect } from "react";
import { P_Props } from "./QuotationForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback } from "../../../../utils";
import { Loading, SimpleModalHeader } from "../../../components";
import { Grid, TextField, Select, FormControl } from "@material-ui/core";
import { QuotationOptionService } from "../../../../models";
import { REGEX } from "../../../../constants";
import moment from "moment";

const QuotationFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const [date, setDate] = useState<string>("")
  const [time, setTime] = useState<string>("")

  useEffect(() => {
    var newData = new Date();
    setDate(newData.toLocaleDateString());
    setTime(newData.toLocaleTimeString());
  }, [])

  return (
    <>
      <div className="quotation-form">
        <SimpleModalHeader
          title="New Quotation"
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="quotation-form__container">
          <div className="quotation-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <h4 className="quotation-form__section">
                            {props.shipmentService === QuotationOptionService.FREIGHTFORWARDING
                              ? "Freight forwarding service"
                              : props.shipmentService === QuotationOptionService.ECOMMERCE
                                ? "E-commerce Fulfillment service"
                                : ""
                            }
                          </h4>
                        </Grid>

                        {props.shipmentService === QuotationOptionService.FREIGHTFORWARDING && (
                          <Grid item xs={12} lg={6}>
                            <Field name="modeOfTransport" validate={FormUtil.Rule.required("This is required field")}>
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Mode of Transport",
                                  <FormControl
                                    style={{ width: "100%" }}
                                    variant="outlined"
                                    className="quotation-form__select"
                                  >
                                    <Select
                                      native
                                      {...input}
                                      {...rest}
                                      value={input.value}
                                      error={meta.error && meta.touched}
                                    >
                                      <option value="">Select...</option>
                                      <option value="Air Freight">Air Freight</option>
                                      <option value="Sea Freight">Sea Freight</option>
                                      <option value="Land/Trucking">Land / Trucking</option>
                                    </Select>
                                  </FormControl>, false, true
                                );
                              }}
                            </Field>
                          </Grid>
                        )}
                        <Grid item xs={12} lg={4}>
                          <Field name="requestDate">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Request Date",
                                <TextField
                                  fullWidth
                                  disabled
                                  placeholder="22/08/2021"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  value={moment(date).format("DD/MM/yyyy")}
                                  onChange={(e) => input.onChange(e.target.value)}
                                />
                                , true, false
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={2}>
                          <Field name="requestTime">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "",
                                <TextField
                                  fullWidth
                                  disabled
                                  className="form-text-field input-time"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  value={time}
                                  onChange={(e) => input.onChange(e.target.value)}
                                />
                              );
                            }}
                          </Field>
                        </Grid>
                        {props.shipmentService === QuotationOptionService.ECOMMERCE && (
                          <Grid item xs={12} lg={6}></Grid>
                        )}
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="fullName"
                            validate={FormUtil.Rule.required("This is required field")}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Customer",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder={"Full name"}
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="email"
                            validate={FormUtil.composeValidators([
                              FormUtil.Rule.required("This is required field"),
                              FormUtil.Rule.pattern(REGEX.EMAIL, { errorMessage: "Invalid email" }),
                            ])}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Email",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Vd: ten@domain.com"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field
                            name="phone"
                            validate={FormUtil.composeValidators([
                              FormUtil.Rule.required("This is required field"),
                              FormUtil.Rule.pattern(REGEX.PHONE_NUMBER, { errorMessage: "Invalid phone number" }),
                            ])}
                          >
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Contact number",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Number"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Field name="companyURL" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Company URL",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="www.vico.com"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12}>
                          <Field name="address" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Address",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Text input"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />, false, true
                              );
                            }}
                          </Field>
                        </Grid>

                        <Grid item xs={12}>
                          <h4 className="quotation-form__section">SHIPPING DETAIL</h4>
                        </Grid>

                        {/* FREIGHT FORWARD SERVICE */}
                        {props.shipmentService === QuotationOptionService.FREIGHTFORWARDING && (
                          <>
                            <Grid item xs={12} lg={6}>
                              <Field name="portOfLoading" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Port of Loading",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="portOfDischarge" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Port of Discharge",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="modeOfService" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Mode of service",
                                    <FormControl
                                      style={{ width: "100%" }}
                                      variant="outlined"
                                      className="quotation-form__select"
                                    >
                                      <Select
                                        native
                                        {...input}
                                        {...rest}
                                        value={input.value}
                                        error={meta.error && meta.touched}
                                      >
                                        <option value="">Select...</option>
                                        <option value="lcl">LCL</option>
                                        <option value="fcl">FCL</option>
                                        <option value="ltl">LTL</option>
                                        <option value="ftl">FTL</option>
                                        <option value="parcel">Parcel</option>
                                      </Select>
                                    </FormControl>, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12}>
                              <h4 className="quotation-form__section">WAREHOUSE</h4>
                            </Grid>
                            <Grid item xs={12}>
                              <Field name="commodity" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Commodity",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="numberOfSKU"
                                validate={FormUtil.Rule.numberOnly("Invalid number")}
                              >
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Number of SKU",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="storage">
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Storage",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />
                                  );
                                }}
                              </Field>
                            </Grid>
                          </>
                        )}

                        {/* E-COMMERCE FULFILLMENT SERVICE */}
                        {props.shipmentService === QuotationOptionService.ECOMMERCE && (
                          <>
                            <Grid item xs={12} lg={6}>
                              <Field name="orderPerMonth" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Order per month",
                                    <FormControl
                                      style={{ width: "100%" }}
                                      variant="outlined"
                                      className="quotation-form__select"
                                    >
                                      <Select
                                        native
                                        {...input}
                                        {...rest}
                                        value={input.value}
                                        error={meta.error && meta.touched}
                                      >
                                        <option value="">Select...</option>
                                        <option value="less than 200">Less than 200</option>
                                        <option value="200 - 499">200 - 499</option>
                                        <option value="500 - 900">500 - 900</option>
                                        <option value="+ 1000">+ 1000</option>
                                      </Select>
                                    </FormControl>, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="itemsPerOrder" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Items per order",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="numberOfSKU" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Number of SKU",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="weightOfParcel" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Weight of Parcel",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="webshopPlatform">
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Webshop platform",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Text input"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Field name="storage" validate={FormUtil.Rule.required("This is required field")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Storage",
                                    <FormControl
                                      style={{ width: "100%" }}
                                      variant="outlined"
                                      className="quotation-form__select"
                                    >
                                      <Select
                                        native
                                        {...input}
                                        {...rest}
                                        value={input.value}
                                        error={meta.error && meta.touched}
                                      >
                                        <option value="">Select...</option>
                                        <option value="1 - 10 Pallets">1 - 10 Pallets</option>
                                        <option value="11 - 50 Pallets">11 - 50 Pallets</option>
                                        <option value="+ 50 Pallets">+ 50 Pallets</option>
                                      </Select>
                                    </FormControl>, false, true
                                  );
                                }}
                              </Field>
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12}>
                          <Field name="note">
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Note",
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  multiline
                                  rows={3}
                                  placeholder="Text input"
                                  className="form-textarea-field"
                                  inputProps={{ className: "input" }}
                                  variant="outlined"
                                  onChange={(e) => input.onChange(e.target.value)}
                                />
                              );
                            }}
                          </Field>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>
        <div className="quotation-form__footer">
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            Create
          </button>
        </div>
      </div>
    </>
  );
};

export default QuotationFormPresenter;